import Setting from "@/assets/conf/setting.json";

export const initWeChat = function(file) {
  window.$swxsdk.initWxSdk(
    {
      tenantId: file.tenantId,
      weChatId: file.weChatId
    },
    Setting.template.api.gateway.general
  );
  if(file.enableShare==1){
    initSharer(file);
  }else {
    enableSharer();
  }
};

export const initSharer = function(file) {
  let shareInfo = {
    title: file.shareTitle,
    desc: file.description,
    link: window.location.href,
    imgUrl: file.shareImageUrl
  };

  window.$swxsdk.on("sharer", shareInfo);
  window.$swxsdk.on("sharer_friends", shareInfo);
};
export const enableSharer = function() {
  window.$swxsdk.on(
    "hideMenuList",
    {
      menuList: [
        "menuItem:share:appMessage",
        "menuItem:share:timeline",
        "menuItem:share:qq",
        "menuItem:share:weiboApp",
        "menuItem:share:facebook",
        "menuItem:share:QZone",
        "menuItem:copyUrl",
        "menuItem:openWithQQBrowser",
        "menuItem:openWithSafari",
        "menuItem:favorite"
      ]
    },
    function(result) {
      console.log(result);
    }
  );
  window.$swxsdk.on("hideOptionMenu");
  console.log('hideOptionMenu---51');
};
